module.exports = __webpack_public_path__ + "img/laptop.b88a5710.png";